// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"91b7aa66edda88dc","229":"b8e5dacc5e982d5c","557":"b91bc79f7d9729b4","646":"0e636499d87f8634"}[chunkId] + ".js";
};